module.exports = __webpack_public_path__ + "img/laboratorio4_4-3_3072.f92bd039.webp";